import { Injectable } from '@angular/core';
import { ToastrService } from "ngx-toastr";

@Injectable({
  providedIn: 'root'
})
export class AlertService {

  constructor(private toastr:ToastrService) { }

  success(title="Mensaje", texto="") {
    this.toastr.success(texto,title);
  }
  info(title="Mensaje", texto="titulo") {
    this.toastr.info(texto,title);
  }
  warning(title="Mensaje", texto="") {
    this.toastr.warning(texto,title);
  }
  error(title="Mensaje", texto="titulo") {
    this.toastr.error(texto,title);
  }

  alertaTiempo(title = "Mensaje", texto="titulo", time: number){
    this.toastr.success(title, texto, { timeOut: time});
  }


alert(t2 ="Titulo", t = "Mensaje",  tipo="success"){
   switch(tipo) {
    case "success": {
       this.toastr.success(t, t2);
       break;
    }
    case "info": {
       this.toastr.info(t, t2);
       break;
    }  case "warning": {
       this.toastr.warning(t, t2);
       break;
    }  case "error": {
       this.toastr.error(t, t2);
       break;
    }
 }
}

createOk(title ="¡Correcto!", text = "Registro creado satisfactoriamente."){
    this.toastr.success(text, title);
}

createError(text ="Ocurrio un error"){
  this.toastr.error(text, '¡Alerta!');

}
updateOk(title ="¡Correcto!", text = "Registro actualizado satisfactoriamente."){
    this.toastr.success(text, title);
}

updateError(text ="No fue posible actualizar el registro"){
  this.toastr.error(text, '¡Error!');

}

deleteOk(title="¡Correcto!",text="Registro eliminado satisfactoriamente." ){
  this.toastr.success(text, title);

  }

deleteError(title= "¡Error!", text= "No fue posible eliminar el registro."){
    this.toastr.error(text, title);
 }

 fechaError(text = "Fecha inicio no puede ser mayor a la fecha fin."){
  this.toastr.warning(text, '¡Atención!');
}

atribucionAlerta(text = "Seleccione una atribución."){
  this.toastr.warning(text, '¡Atención!');
}

RepetirNombre(text = "Existe un catálogo con el mismo nombre."){
  this.toastr.warning(text, '¡Atención!');
}


RepetirNombreEstr(text = "Existe una estrategia con el mismo nombre."){
  this.toastr.warning(text, '¡Atención!');
}
EliminarRegistro(text = "No se puede borrar este registro, ya que existe datos relacionados."){
  this.toastr.warning(text, '¡Atención!');
}


EliminarRegistroCatalogo(text = "No se puede borrar este catálogo, ya que existe registros relacionados."){
  this.toastr.warning(text, '¡Atención!');
}

EstrategiasAgregar(text = "Algún objetivo no tiene una !Estrategia!"){
  this.toastr.warning(text, '¡Atención!');
}

EstrategiaNuevo(text = "Cuando se cree este objetivo debe tener al menos una !Estrategia!"){
  this.toastr.warning(text, '¡Atención!');
}

alertActividades(text = "No se puede borrar este registro, Actividades relacionadas!"){
  this.toastr.warning(text, '¡Atención!');
}


}
